import { Import } from '@/app/types/productServiceType'
import { sortByName } from '@/app/utils/formatListData'

export const getProductsList = async (productName: string) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/products/search?name=${productName}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responseData = await response.json()
    return sortByName(responseData?.products) ?? []
  } catch (error) {
    console.error('Error ', error)
    return []
  }
}

export const getProductVarietyList = async (
  varietyName: string,
  typeId: number
) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/varieties/search?name=${varietyName}&product=${typeId}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responseData = await response.json()
    return sortByName(responseData?.varieties) ?? []
  } catch (error) {
    console.error('Error:', error)
    return []
  }
}

export const getUnits = async () => {
  try {
    const response = await fetch(`${process.env.API_URL}/units`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const responseData = await response.json()
    return responseData
  } catch (error) {
    console.log('Error:', error)
  }
}

export const getSingleProduct = async (id: number) => {
  try {
    const response = await fetch(
      `${process.env.API_URL}/company_products/${id}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responseData = await response.json()
    return responseData.company_product
  } catch (error) {
    console.log(error)
  }
}

export const getProductTypes = async () => {
  const response = await fetch(`${process.env.API_URL}/product_types`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  const responseData = await response.json()
  return responseData
}

export const formatLogisticsData = (LogisticData: Import[]) => {
  const newLogisticData: string[] = []
  LogisticData?.forEach((element: Import) => {
    if (element.country) {
      newLogisticData.push(element.country)
    }
  })

  return newLogisticData
}

export const LogisticsDataToId = (LogisticData: Import[], name: string) => {
  let newLogisticData: number = 0
  LogisticData?.forEach((element: Import) => {
    if (element.country === name) {
      newLogisticData = element.id
    }
  })

  return newLogisticData
}
